import { render, staticRenderFns } from "./AboutFact.vue?vue&type=template&id=72571e54&scoped=true"
import script from "./AboutFact.vue?vue&type=script&lang=ts"
export * from "./AboutFact.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72571e54",
  null
  
)

export default component.exports